import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'
import { TransferOutDestination } from './mockTransferOutApi'

interface Props {
  isOpen: boolean
  selectedCount: number
  destination: TransferOutDestination
  isSubmitting: boolean
  onDestinationChange: (destination: TransferOutDestination) => void
  onClose: () => void
  onConfirm: () => void
}

const TransferOutModal: React.FC<Props> = ({
  isOpen,
  selectedCount,
  destination,
  isSubmitting,
  onDestinationChange,
  onClose,
  onConfirm,
}) => {
  const modalsRoot = document.getElementById('root-modals') || document.body

  return createPortal(
    <Modal
      id='kt_modal_transfer_out'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={isOpen}
      onHide={onClose}
      backdrop={isSubmitting ? 'static' : true}
      keyboard={!isSubmitting}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>ขนส่งเสา</h2>
          {!isSubmitting && (
            <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={onClose}>
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
            </div>
          )}
        </div>

        <div className='modal-body'>
          <p className='text-gray-700 mb-5'>
            เลือกแล้ว <span className='fw-bold'>{selectedCount}</span> ท่อน — เลือกปลายทางการขนส่ง
          </p>

          <div className='form-check mb-3'>
            <input
              className='form-check-input'
              type='radio'
              name='transferDestination'
              id='destination-factory'
              checked={destination === 'factory'}
              disabled={isSubmitting}
              onChange={() => onDestinationChange('factory')}
            />
            <label className='form-check-label fw-bold text-gray-800' htmlFor='destination-factory'>
              ส่งกลับโรงงาน
            </label>
          </div>
        </div>

        <div className='modal-footer'>
          <button
            type='button'
            className='btn btn-light fw-bold'
            disabled={isSubmitting}
            onClick={onClose}>
            ยกเลิก
          </button>
          <button
            type='button'
            className='btn btn-primary fw-bold'
            disabled={isSubmitting}
            onClick={onConfirm}>
            {isSubmitting ? (
              <>
                <span className='spinner-border spinner-border-sm me-2' />
                กำลังขนส่ง...
              </>
            ) : (
              'ยืนยัน'
            )}
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default TransferOutModal
